import angular from 'angular';
import { AlternateBrandsModule, StepPageModule } from '../../common/directives';
import { CardModule } from '../../core';
import { AutoInsuranceConfig } from './auto-insurance.config';
import { AutoInsuranceComponent } from './auto-insurance.component';

export const AutoInsuranceStepModule = angular
  .module('app.steps.auto-insurance', [
    StepPageModule.name,
    AlternateBrandsModule.name,
    CardModule.name,
  ])
  .config(AutoInsuranceConfig)
  .component('updAutoInsurance', AutoInsuranceComponent);
